import React from "react"

import ProgressBar from "../../design-system/progress-bar"
import useScrollPosition from "../../utils/hooks/use-scroll-position"

type Props = {
  scrollableElementRef: React.RefObject<HTMLElement>
}

function PageScrollProgressBar({ scrollableElementRef }: Props) {
  const scrollableElement = scrollableElementRef.current
  const scrollPosition = useScrollPosition(scrollableElement)

  if (!scrollableElement) {
    return null
  }

  const { scrollHeight, clientHeight: containerHeight } = scrollableElement
  const scrollableDistance = scrollHeight - containerHeight
  const scrollFraction = scrollPosition / scrollableDistance
  const displayedFraction = Number.isNaN(scrollFraction) ? 0 : scrollFraction

  return <ProgressBar percentage={displayedFraction * 100} />
}

export default PageScrollProgressBar
